import { Outlet } from 'react-router-dom'

const CareRoot = () => {
  return <Outlet />
}

export { CareRoot }
